import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useDashboard } from '@/lib/queries';

export function DashboardPage() {
  const data = useDashboard();
  const d = data.data;
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Dashboard</h1>
        <p className="text-muted-foreground">Last 30 days</p>
      </div>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        <Stat title="Open tickets" value={d?.openTickets} />
        <Stat title="Closed (30d)" value={d?.closedTicketsLast30d} />
        <Stat title="New users (30d)" value={d?.newUsersLast30d} />
      </div>
      <Card>
        <CardHeader>
          <CardTitle>Tickets per day</CardTitle>
          <CardDescription>Opened vs closed</CardDescription>
        </CardHeader>
        <CardContent className="h-72">
          {d && (
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={d.ticketTimeseries}>
                <CartesianGrid strokeDasharray="3 3" opacity={0.3} />
                <XAxis dataKey="day" tick={{ fontSize: 11 }} />
                <YAxis tick={{ fontSize: 11 }} allowDecimals={false} />
                <Tooltip />
                <Legend />
                <Line type="monotone" dataKey="opened" stroke="#5865f2" strokeWidth={2} />
                <Line type="monotone" dataKey="closed" stroke="#e74c3c" strokeWidth={2} />
              </LineChart>
            </ResponsiveContainer>
          )}
        </CardContent>
      </Card>
    </div>
  );
}

function Stat({ title, value }: { title: string; value: number | undefined }) {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardDescription>{title}</CardDescription>
        <CardTitle className="text-3xl">{value ?? '—'}</CardTitle>
      </CardHeader>
    </Card>
  );
}
